import React from "react";
import { Grid, TextField } from "@mui/material";

const PricingSection = ({ form, updateField }) => {
  if (form.isComponent) return null; // Hide pricing for reusable components

  return (
    <>
      <Grid item xs={6}>
        <TextField
          type="number"
          label="Waste Buffer %"
          fullWidth
          value={form.wasteBufferPercent}
          onChange={(e) => updateField("wasteBufferPercent", e.target.value)}
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          type="number"
          label="Unit Price ($)"
          fullWidth
          value={form.unitPrice}
          onChange={(e) => updateField("unitPrice", e.target.value)}
        />
      </Grid>
    </>
  );
};

export default PricingSection;
